import { api } from '../api/client';
import { API_URL } from '../utils';

/**
 * Upload requests (KPR-183; keepr-api docs/SCHEMA.md § Upload requests): an
 * agent's list of items waiting for files. The web only READS one — the link
 * the agent hands the person is the items page with `?attach=<id>` — and the
 * person's own session is what makes it readable: anyone else, an expired or
 * withdrawn request, gets the API's one 404.
 */
export const API_UPLOAD_REQUEST_URL = id => `${API_URL}/upload-requests/${id}`;

export async function getUploadRequest(id) {
	const { data } = await api.get(API_UPLOAD_REQUEST_URL(id));
	return data;
}
